<template>
<div class='wrapper'>
  <div class='panel code-panel'>
    <v-tabs
      class='tabs-wrapper'
      >
      <v-tab
        v-for="item in tabs"
        :key="item.key"
        >
        {{item.tab}}
        </v-tab>
        <v-tab-item v-for="item in tabs" :key="item.key">
        <gh-code-editor
          class='code-wrapper'
          v-model="item.value"
          :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:item.language}"
          />
        </v-tab-item>
    </v-tabs>
  </div>
  <div class="preview-btn-wrapper">
    <v-btn @click="addRouter">
      测试
    </v-btn>
    <v-btn @click="navigateTo">
      导航1
    </v-btn>
    <v-btn @click="navigateToComp">
      导航2
    </v-btn>
    <v-btn
      @click="onClickPreview"
      >
      预览 >>
    </v-btn>
  </div>
  <div class='panel preview-panel'>
    <!-- <v-alert message="通过实例化Vue挂载DOM的方式渲染" type="info" show-icon /> -->
    <mount-component v-bind="previewData"/>
    <!-- <code-component v-bind="previewData" /> -->
    <!-- <v-divider/> -->
    <!-- <a-alert message="通过实例化Vue挂载DOM的方式渲染" type="info" show-icon />
    <with-mount v-bind="previewData"/>
    <a-divider/>
    <a-alert message="通过实例化Vue挂载到iframe的方式渲染" type="info" show-icon />
    <mount-same-iframe v-bind="previewData"/>
    <a-divider/>
    <a-alert message="通过实例化Vue挂载到iframe的方式渲染" type="info" show-icon />
    <mount-cross-iframe v-bind="previewData"/>
    <a-divider/> -->
  </div>
</div>
</template>

<script>
import Vue from "vue";
import GhCodeEditor from "@/components/ghCodeEditor/ghCodeEditor";
import mountComponent from "@/components/mountComponent";
import codeComponent from "@/components/codeComponent";
import GhClassService from "@/utils/mixins/clsService";
import { template, js, css } from "./service";
import { Mixins, Component } from "vue-property-decorator";

export default {
  name: "",
  components: {
    GhCodeEditor,
    mountComponent,
    codeComponent
  },
  data() {
    return {
      previewData: {
        js: "",
        template: "",
        css: ""
      },
      tabs: {
        template: {
          key: "template",
          tab: "模板",
          value: template,
          mode: "text/x-vue",
          language: "html"
        },
        js: {
          key: "js",
          tab: "代码",
          value: js,
          mode: "text/javascript",
          language: "javascript"
        },
        css: {
          key: "css",
          tab: "样式",
          value: css,
          mode: "text/css",
          language: "css"
        }
      }
    };
  },
  methods: {
    onClickPreview() {
      this.previewData = {
        template: this.tabs.template.value,
        js: this.tabs.js.value,
        css: this.tabs.css.value,
        sed: Math.random()
      };
      console.log("code==>", this.previewData);
    },
    addRouter() {
      let comp = Vue.extend(codeComponent, {
        mixins: [GhClassService]
      });
      console.log(this.previewData);
      // let com = new comp({
      //   // el: "#app",
      //   propsData: this.previewData
      // });
      // // console.log(comp, com);
      // @Component(comp)
      // class X extends Mixins(GhClassService) {}

      // console.log("X===>", X);

      let r = {
        name: "vuejstest",
        path: "/test/vuejstest",
        component: comp,
        props: this.previewData
      };

      let rs = {
        name: "main",
        path: "/main",
        component: () => import("@/portal/main/main")
      };
      let children = [];
      children.push(r);
      rs.children = children;
      this.$router.addRoutes([rs]);
    },
    navigateTo() {
      console.log("123");
      this.$router.push({ name: "portal.custom.test" });
    },
    navigateToComp() {
      console.log("2222");
      this.$router.push({ name: "vuejstest" });
    }
  },
  created() {
    // this.$store.commit("setState", {
    //   filePath: "views/customCode/index.vue",
    //   pageName: ""
    // });
  },
  mounted() {
    this.previewData = {
      template: this.tabs.template.value,
      js: this.tabs.js.value,
      css: this.tabs.css.value
    };
    // setInterval(() => {
    //   let { varA } = this.$store.state.variable.map;
    //   varA += 1;
    //   this.$store.commit("variable/setState", { map: { varA } });
    // }, 1000 * 10);
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  padding: 10px;
  flex-grow: 1;

  .panel {
    border: 1px solid #ccc;
    height: 100%;
    text-align: left;
    overflow: auto;
    flex-grow: 1;
    max-width: 700px;
  }

  .preview-btn-wrapper {
    margin: 10px;
  }

  .tabs-wrapper {
    height: 100%;

    .code-wrapper {
      height: 100%;
    }
  }
}
</style>
